import store from './store/index'
import { SysConsoleProviderModule } from '@/system-modules/console/ConsoleProvider'
import ModulesReg from '@/modules/ModulesReg'
import config from '@/config'
import { ISysModManagerModule } from '@/contracts/system-modules/mod-manager/ISysModManagerModule'
import { ISysConsoleModule } from '@/contracts/system-modules/console/ISysConsoleModule'
import { IModule } from '@/contracts/core/module/interface/IModule'
import { EnumConsoleType } from '@/contracts/system-modules/console/enum/EnumConsoleType'
import { IStore } from './core/interface/IStore'

class ModManagerV1 implements ISysModManagerModule {
  private store: IStore = store()
  private static instance: ISysModManagerModule
  private console: ISysConsoleModule

  init(): boolean {
    this.loadModules()
    this.console.log('ModManager module initialized', EnumConsoleType.SUCCESS)
    return true
  }

  static getInstance(): ISysModManagerModule {
    if (!ModManagerV1.instance) {
      ModManagerV1.instance = new ModManagerV1()
    }
    return ModManagerV1.instance
  }

  constructor() {
    this.console = SysConsoleProviderModule()
  }

  loadModules(): void {
    for (const k in config.modules) {
      const modInfo = config.modules[k]
      try {
        this.store.modules[modInfo.getModuleId()] = ModulesReg().getModule(modInfo.getModuleId())
        this.console.log(`Module ${modInfo.getCode()} ${modInfo.getVersion()} initialized`, EnumConsoleType.SUCCESS)
      } catch (e) {
        this.console.log(`${e}`, EnumConsoleType.ERROR)
      }
    }
  }

  get(modName: string): IModule {
    return this.store.modules[modName]
  }

  getAll(): { [key: string]: IModule } {
    return this.store.modules
  }
}

export default function(): ISysModManagerModule {
  return ModManagerV1.getInstance()
}
